import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { colors } from '../theme';

const API = process.env.REACT_APP_API_URL;
const LABELS = {
  none: 'Tanpa Efek',
  warm: 'Warm', cool: 'Cool', vivid: 'Vivid', film: 'Film',
  moody: 'Moody', golden: 'Golden', clean: 'Clean', noir: 'Noir',
  pastel: 'Pastel', neon: 'Neon', vignette: 'Vignette',
  soft_glow: 'Soft Glow', sharp: 'Sharp', grain: 'Grain',
  bright_lift: 'Bright Lift', soft_zoom: 'Soft Zoom',
  zoom_static: 'Zoom Static', zoom_tight: 'Zoom Tight',
  letterbox: 'Letterbox', mirror: 'Mirror',
  lifestyle: 'Lifestyle', cinematic: 'Cinematic',
  music_dance: 'Music / Dance', retro: 'Retro', premium: 'Premium',
  minimal: 'Minimal', night: 'Night', documentary: 'Documentary'
};

export default function ChannelSettings({ kind, row, onSaved, artists }) {
  const [presets, setPresets] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [local, setLocal] = useState(row);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState('');

  const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('sm_token')}` } });

  useEffect(() => {
    axios.get(`${API}/api/branding/presets`, hdr())
      .then(r => { setPresets(r.data.presets || []); setProfiles(r.data.profiles || []); })
      .catch(() => {});
  }, []);

  useEffect(() => { setLocal(row); }, [row]);

  function edit(field, value) {
    setLocal(r => ({ ...r, [field]: value }));
  }

  async function save() {
    setSaving(true); setMsg('');
    try {
      const url = kind === 'instagram'
        ? `${API}/api/branding/instagram`
        : kind === 'igacct'
        ? `${API}/api/branding/instagram/account/${local.id}`
        : `${API}/api/branding/${kind}/${local.id}`;
      await axios.put(url, {
        brand_effect_preset: local.brand_effect_preset || 'none',
        default_post_time: local.default_post_time || null,
        stagger_minutes: parseInt(local.stagger_minutes) || 0
      }, hdr());
      setMsg('Tersimpan');
      if (onSaved) onSaved();
      setTimeout(() => setMsg(''), 2500);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal menyimpan');
    }
    setSaving(false);
  }

  async function uploadLogo(file) {
    if (!file) return;
    setUploading(true); setMsg('');
    try {
      const fd = new FormData();
      fd.append('logo', file);
      const q = kind === 'tiktok' ? '?type=tiktok' : kind === 'igacct' ? '?type=instagram' : '';
      await axios.post(`${API}/api/logo/channel/${local.id}${q}`, fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('sm_token')}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      setMsg('Logo tersimpan');
      if (onSaved) onSaved();
      setTimeout(() => setMsg(''), 2500);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal upload logo');
    }
    setUploading(false);
  }

  async function assignArtist(artistId) {
    setSaving(true); setMsg('');
    try {
      await axios.put(`${API}/api/artists/assign/${kind === 'igacct' ? 'instagram' : kind}/${local.id}`, { artist_id: artistId || null }, hdr());
      setLocal(r => ({ ...r, artist_id: artistId || null }));
      setMsg('Artis diperbarui');
      setTimeout(() => setMsg(''), 2500);
    } catch (e) {
      setMsg(e.response?.data?.error || 'Gagal mengubah artis');
    }
    setSaving(false);
  }

  async function removeLogo() {
    setUploading(true); setMsg('');
    try {
      const q = kind === 'tiktok' ? '?type=tiktok' : kind === 'igacct' ? '?type=instagram' : '';
      await axios.delete(`${API}/api/logo/channel/${local.id}${q}`, hdr());
      setMsg('Logo dihapus');
      if (onSaved) onSaved();
      setTimeout(() => setMsg(''), 2500);
    } catch (e) {
      setMsg('Gagal hapus logo');
    }
    setUploading(false);
  }

  return (
    <div style={{ background: colors.bgCardMuted, borderRadius: 10, padding: 14, marginTop: 10, border: `1px solid ${colors.border}` }}>
      {artists && artists.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 6 }}>Artis</div>
          <select value={local.artist_id || ''} onChange={e => assignArtist(e.target.value)} style={{ width: '100%', fontSize: 12 }}>
            <option value="">-- Belum ter-assign --</option>
            {artists.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
        </div>
      )}
      {msg && (
        <div style={{ fontSize: 12, marginBottom: 10, color: msg === 'Tersimpan' || msg === 'Logo tersimpan' || msg === 'Logo dihapus' ? colors.success : colors.danger }}>
          {msg}
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 10, marginBottom: 10 }}>
        <div>
          <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 6 }}>Efek Branding</div>
          <select
            value={(kind === 'instagram' ? local.ig_effect_preset : local.brand_effect_preset) || 'none'}
            onChange={e => edit('brand_effect_preset', e.target.value)}
            style={{ width: '100%', fontSize: 12 }}
          >
            <option value="none">Tanpa Efek</option>
            <optgroup label="Paket Profile">
              {profiles.map(p => <option key={p} value={p}>{LABELS[p] || p}</option>)}
            </optgroup>
            <optgroup label="Efek Tunggal">
              {presets.map(p => <option key={p} value={p}>{LABELS[p] || p}</option>)}
            </optgroup>
          </select>
        </div>
        <div>
          <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 6 }}>Jam Upload</div>
          <input
            type="time"
            value={((kind === 'instagram' ? local.ig_post_time : local.default_post_time) || '').slice(0, 5)}
            onChange={e => edit('default_post_time', e.target.value)}
            style={{ fontSize: 12 }}
          />
        </div>
        <div>
          <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 6 }}>Jeda (menit)</div>
          <input
            type="number" min="0" max="1440"
            value={(kind === 'instagram' ? local.ig_stagger_minutes : local.stagger_minutes) ?? 0}
            onChange={e => edit('stagger_minutes', e.target.value)}
            style={{ fontSize: 12 }}
          />
        </div>
      </div>

      {kind === 'youtube' && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 11, color: colors.textSecondary }}>Watermark:</span>
          {local.brand_watermark_path
            ? <span style={{ fontSize: 12, color: colors.success }}>terpasang</span>
            : <span style={{ fontSize: 12, color: colors.textSecondary }}>pakai logo utama</span>}
          <label style={{ fontSize: 12, color: colors.accent, cursor: 'pointer', textDecoration: 'underline', textUnderlineOffset: 3 }}>
            {uploading ? 'memproses...' : 'Ganti'}
            <input type="file" accept=".png,.jpg,.jpeg" style={{ display: 'none' }}
              onChange={e => { uploadLogo(e.target.files[0]); e.target.value = ''; }} />
          </label>
          {local.brand_watermark_path && (
            <span onClick={removeLogo}
              style={{ fontSize: 12, color: colors.danger, cursor: 'pointer', textDecoration: 'underline', textUnderlineOffset: 3 }}>
              Hapus
            </span>
          )}
        </div>
      )}

      <button className="btn btn-gold" disabled={saving} onClick={save} style={{ fontSize: 12, padding: '6px 16px' }}>
        {saving ? '...' : 'Simpan Pengaturan'}
      </button>
    </div>
  );
}
